<template>
  <div>
    <v-card class="mb-4">
      <v-card-title>{{ $t("Icon") }}</v-card-title>
      <v-card-text>
        <v-row no-gutters>
          <v-col xs="12" sm="4" lg="4">
            <v-autocomplete
              v-if="allIcons"
              v-model="page.Icon"
              :loading="loading"
              :items="allIcons"
              class="mr-4"
              flat
              item-value="icon"
              item-text="name"
              :append-outer-icon="page.Icon"
              :label="$t('Select an icon')"
            >
              <template v-slot:item="{ item }">
                <v-icon>
                  {{ item.icon }}
                </v-icon>
                <span class="ml-2">
                  {{ item.name }}
                </span>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import json from "../../locale/Icons";

export default {
  props: {
    page: {
      type: [Array, Object],
    },
    loading: {
      type: Boolean,
    },
  },
  data() {
    return {
      allIcons: json.icons(),
    };
  },
};
</script>

<style>
</style>